import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "modal-content"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "container-widget"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "width-5vw" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "column margin-left-20px" }
const _hoisted_10 = { class: "h4" }
const _hoisted_11 = { class: "description" }
const _hoisted_12 = { class: "arrow" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 2,
  class: "flex"
}
const _hoisted_15 = { class: "width-50pct" }
const _hoisted_16 = { class: "margin-sites-dispo" }
const _hoisted_17 = { class: "input-container-with-icon" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "sites-list-container" }
const _hoisted_21 = { class: "bar-verticale width-50pct" }
const _hoisted_22 = { class: "margin-left-3pct" }
const _hoisted_23 = { class: "margin-top-3pct" }
const _hoisted_24 = { class: "flex wrap sites-list-container recap-sites-list-container" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { class: "color-grey" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = {
  key: 4,
  class: "bar-horizontale"
}
const _hoisted_30 = {
  key: 5,
  class: "boutons"
}
const _hoisted_31 = { class: "boutons-gauche" }
const _hoisted_32 = { class: "boutons-droite" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_CreationWidgetStepsBar = _resolveComponent("CreationWidgetStepsBar")!
  const _component_check_box = _resolveComponent("check-box")!
  const _component_ButtonWhite = _resolveComponent("ButtonWhite")!
  const _component_BoutonBleu = _resolveComponent("BoutonBleu")!

  return (_ctx.enregistrementEnCours)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h2", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('dashboard.parametrable.modale.widget.titre.' + _ctx.step)), 1),
          (_ctx.step !== 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "\" " + _toDisplayString(_ctx.widgetSelectionne.libelle) + " \"", 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.step === 1)
          ? (_openBlock(), _createBlock(_component_ReglePastille, {
              key: 0,
              cle: "editionDashboard.widgetFacturationReserve",
              placement: "bottom"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_CreationWidgetStepsBar, {
          step: _ctx.step,
          "without-step-one": _ctx.widgetAModifier != null || _ctx.widgetADupliquer != null
        }, null, 8, ["step", "without-step-one"]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "bar-horizontale" }, null, -1)),
        (_ctx.step === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listeWidgets, (widget) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: widget.id,
                  class: "div-widget-container",
                  onClick: ($event: any) => (_ctx.selectWidget(widget))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    (widget.id === 1)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.loadImageDonut,
                          alt: "",
                          class: "image-widget"
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true),
                    (widget.id === 2)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: _ctx.loadImageBarresEtDonut,
                          alt: "",
                          class: "image-widget"
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true),
                    (widget.id >= 3)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 2,
                          src: _ctx.loadImageBarres,
                          alt: "",
                          class: "image-widget-large"
                        }, null, 8, _hoisted_8))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.$t(widget.libelle)), 1),
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(widget.description)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("img", {
                      src: _ctx.loadIconArrowright,
                      alt: "",
                      class: "image-arrow"
                    }, null, 8, _hoisted_13)
                  ])
                ], 8, _hoisted_4))
              }), 128))
            ]))
          : (_ctx.listeSitesDisponibles.length !== 0 && _ctx.step === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$t('dashboard.parametrable.modale.creation.dashboard.bouton.sites.disponibles')), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("img", {
                      src: _ctx.loadIconSearch,
                      alt: "search",
                      class: "icon-search"
                    }, null, 8, _hoisted_18),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
                      placeholder: 
                            _ctx.$t('dashboard.parametrable.modale.creation.dashboard.bouton.sites.recherche.placeholder')
                        ,
                      class: "input-recherche-site input",
                      onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filtrerSite && _ctx.filtrerSite(...args)))
                    }, null, 40, _hoisted_19), [
                      [_vModelText, _ctx.filter]
                    ])
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "demi-bar-horizontale" }, null, -1)),
                  _createVNode(_component_check_box, {
                    checked: 
                        _ctx.listeSitesSelectionnees == null ||
                        _ctx.listeSitesDisponibles.length === _ctx.listeSitesSelectionnees.length
                    ,
                    label: _ctx.$t('dashboard.parametrable.modale.creation.dashboard.bouton.sites.tous'),
                    partiel: 
                        _ctx.listeSitesSelectionnees != null &&
                        _ctx.listeSitesSelectionnees?.length !== 0 &&
                        _ctx.listeSitesSelectionnees?.length !== _ctx.listeSitesDisponibles.length
                    ,
                    onClick: _ctx.selectionnerTousLesSites
                  }, null, 8, ["checked", "label", "partiel", "onClick"]),
                  _createVNode(_component_ReglePastille, { cle: "editionDashboard.widgetPerimetreSites" }),
                  _createVNode(_component_ReglePastille, { cle: "editionDashboard.widgetSelectionComportement" }),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "demi-bar-horizontale-2" }, null, -1)),
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listeSitesDisponibles, (site) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: site.id
                      }, [
                        _createVNode(_component_check_box, {
                          checked: _ctx.isSiteSelectionnee(site.id),
                          label: site.description,
                          class: "checkbox-site",
                          onClick: ($event: any) => (_ctx.ajouterSite(site))
                        }, null, 8, ["checked", "label", "onClick"])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.$t('dashboard.parametrable.modale.widget.titre.secondaire.perimetre')), 1)
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "demi-bar-horizontale-right" }, null, -1)),
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listeSitesSelectionnees, (site) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: site.id,
                        class: "pastille"
                      }, [
                        _createElementVNode("span", {
                          class: "cursor-pointer",
                          onClick: ($event: any) => (_ctx.ajouterSite(site))
                        }, _toDisplayString(site.description) + " X", 9, _hoisted_25)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
        (_ctx.step === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('dashboard.parametrable.modale.widget.autre.parametre.titre')), 1),
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('dashboard.parametrable.modale.widget.autre.parametre.infos')), 1),
              (_ctx.step === 3)
                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                    key: 0,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.denominationWidget) = $event)),
                    placeholder: _ctx.$t('dashboard.parametrable.modale.widget.autre.parametre.input.placeholder') + ' *',
                    class: "input"
                  }, null, 8, _hoisted_28)), [
                    [_vModelText, _ctx.denominationWidget]
                  ])
                : _createCommentVNode("", true),
              _createVNode(_component_ReglePastille, { cle: "editionDashboard.widgetDenominationObligatoire" }),
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('dashboard.parametrable.modale.widget.autre.parametre.autre.parametres.titre')), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.step > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29))
          : _createCommentVNode("", true),
        (_ctx.step > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_ButtonWhite, {
                  "on-click": _ctx.cancel,
                  text: _ctx.$t('dashboard.parametrable.modale.creation.dashboard.bouton.annuler'),
                  class: "boutonAnnuler"
                }, null, 8, ["on-click", "text"]),
                (_ctx.step > 1 && (_ctx.widgetADupliquer == null || _ctx.widgetAModifier == null))
                  ? (_openBlock(), _createBlock(_component_ButtonWhite, {
                      key: 0,
                      "on-click": _ctx.precedent,
                      text: _ctx.$t('dashboard.parametrable.modale.creation.dashboard.bouton.precedent'),
                      class: "boutonPrecedent"
                    }, null, 8, ["on-click", "text"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_BoutonBleu, {
                  class: _normalizeClass([{ boutonCreer: _ctx.step === 3, boutonEnregistrer: _ctx.step === 2 }, "boutonSuivant"]),
                  disabled: _ctx.isInputDisabled,
                  "on-click": _ctx.suivant,
                  text: _ctx.textBoutonSuivant,
                  "with-check": _ctx.step === 3
                }, null, 8, ["class", "disabled", "on-click", "text", "with-check"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}